<script setup lang="ts">
import { computed } from "vue"

import useTranslation from "@Composables/useTranslation"
import { toShortDate } from "@Helpers/support"

//
// Setup
const { __ } = useTranslation()

//
// Props
interface Props {
  endsAt: string | null
}
const props = defineProps<Props>()

//
// Computed
const endDate = computed((): string => (props.endsAt ? toShortDate(props.endsAt) : ""))
</script>

<template>
  <div class="org-cancellation-banner _cancellation_banner">
    {{ __("plan_information_banner.cancellation_in_progress", { endDate }) }}
  </div>
</template>
